import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../qms/qms.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { asyncScheduler, forkJoin, scheduled } from 'rxjs';
import { AuService } from '../qms/au/au.service';

@Component({
  selector: 'app-quick-access',
  templateUrl: './quick-access.component.html',
  styleUrls: ['./quick-access.component.scss']
})

export class QuickAccessComponent {

  isProcessing: boolean = true;

  datepickerDateCustomClasses: DatepickerDateCustomClasses[];
  moduleList: any = []
  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, public message: messageService, private elem: ElementRef,
    public qualityService: qmsService, public auService: AuService, public paginationService: PaginationService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getcallMethod();
    this.appService.getCodeListsByGroup("MODULES").subscribe((modules: any) => {
      this.moduleList = modules;
    })
  }

  ecData: any = {};
  auditData: any = {};
  documentData: any = {};
  trainingData: any = {};
  scheduledTrainingData: any = {};

  selectedOwner: any = [];
  selectedCheckRequiredFor: any = [];

  dropDownForOwner: any = [];
  dropDownFordocumentTypeList: any = [];
  dropDownForCategories: any = [];
  dropDownForAuditGroup: any = [];

  ownerListDropdown: any = [];
  checkRequiredForListDropdown: any = [];

  popupDataTitle: any;
  loggedOrgId: any;
  loggedUserId: any;

  navigate(quickAccess: any) {
    console.log(quickAccess);

    this.isProcessing = true;

    this.message.taskLevelData = {};
    this.qualityService.cancelButtonFrom = "myTask";
    this.qualityService.taskModuleName = quickAccess.MODULE_CODE;
    this.qualityService.moduleName = quickAccess.MODULE_CODE;
    this.qualityService.moduleFullName = this.moduleList.find((x: any) => x.codelistCode == quickAccess.MODULE_CODE).codelistName;
    this.qualityService.activityId = quickAccess.TASK_NO;
    this.message.activityId = quickAccess.TASK_NO;
    this.message.showLeftMenu = 'Main';

    switch (quickAccess.MODULE_CODE) {

      case 'CR':
        this.appService.getCrByCrNo(quickAccess.TASK_NO).subscribe((activityData: any) => {
          this.qualityService.activity = activityData;
          this.qualityService.selectedActivityGroupId = activityData.groupId;
          this.qualityService.selectedGroup = activityData.groupId;
          this.activityNavigation(quickAccess, activityData);
        })
        break;

      case 'CAPA':
        this.appService.getCapaVwDetailsByCapaNo(quickAccess.TASK_NO).subscribe((activityData: any) => {
          this.qualityService.activity = activityData;
          this.qualityService.selectedActivityGroupId = activityData.groupId;
          this.qualityService.selectedGroup = activityData.groupId;
          this.activityNavigation(quickAccess, activityData);
        })
        break;

      case 'DV':
        this.appService.getDvByDvNo(quickAccess.TASK_NO).subscribe((activityData: any) => {
          this.qualityService.activity = activityData;
          this.qualityService.selectedActivityGroupId = activityData.groupId;
          this.qualityService.selectedGroup = activityData.groupId;
          this.activityNavigation(quickAccess, activityData);
        })
        break;

      case 'IN':
        this.appService.getIncidentDetailsByInNo(quickAccess.TASK_NO).subscribe((activityData: any) => {
          this.qualityService.activity = activityData;
          this.qualityService.selectedActivityGroupId = activityData.groupId;
          this.qualityService.selectedGroup = activityData.groupId;
          this.activityNavigation(quickAccess, activityData);
        })
        break;

      case 'QI':
        this.appService.getQiVwDetailsByQiNo(quickAccess.TASK_NO).subscribe((activityData: any) => {
          this.qualityService.activity = activityData;
          this.qualityService.selectedActivityGroupId = activityData.groupId;
          this.qualityService.selectedGroup = activityData.groupId;
          this.activityNavigation(quickAccess, activityData);
        })
        break;

      case 'CC':
        this.appService.getCcDetailsByCcNo(quickAccess.TASK_NO).subscribe((activityData: any) => {
          this.qualityService.activity = activityData;
          this.qualityService.selectedActivityGroupId = activityData.groupId;
          this.qualityService.selectedGroup = activityData.groupId;
          this.activityNavigation(quickAccess, activityData);
        })
        break;

      case 'AU':
        this.appService.getAuByAuNo(this.qualityService.activityId).subscribe((data: any) => {
          this.auService.isAuditor = data.leadAuditor == this.message.getUserId();
          this.qualityService.activity = data;
          this.qualityService.selectedActivityGroupId = this.qualityService.selectedGroup = data.groupId;
          this.qualityService.activityId = this.message.activityId = quickAccess.TASK_NO;
          this.auService.auditPageFrom = "MyTask";
          this.qualityService.auditEditmodeDatas = { pageName: "" };
          if (quickAccess.SUB_ACTIVITY == 'Extension' || quickAccess.SUB_ACTIVITY == 'Findings' || quickAccess.SUB_ACTIVITY == 'Followups' || quickAccess.SUB_ACTIVITY == 'Followup') {
            this.isProcessing = false;
            this.qualityService.activityDynamicButtonList = [];
            this.auService.tabName = 'Conduct Audit';
            this.auService.findingId = quickAccess.SUB_ACTIVITY_NO;

            this.qualityService.moduleName = "AU";
            this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
            //this.auComponent.ngOnInit();
            this.qualityService.cancelButtonFrom = "myTask";

            this.appService.getQmsGroupDetailsByModule(data.groupId, this.qualityService.moduleName).subscribe((data1: any) => {
              this.qualityService.selectedGroupDetailData = data1;
            });
            this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qualityService.moduleName).subscribe((response1: any) => {
              this.qualityService.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qualityService.userRole[0].groupId,
                displayExp: this.qualityService.userRole[0].groupName
              }];
              this.qualityService.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qualityService.groupNameAndValue = this.selectedGroupValue;
              this.qualityService.selectedGroupDetailId = response1[0].groupDetailId;
              if (this.qualityService.userRole[0]?.qmsRoles.includes("Auditor")) {
                this.qualityService.loggedAuditor = true;
              } else {
                this.qualityService.loggedAuditor = false;
              }

              this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
              let list: any = {};
              this.message.activityId = this.qualityService.activityId = list.AU_NO = data.auNo;
              this.qualityService.selectedActivityGroupId = list.GROUP_ID = data.groupId;
              this.qualityService.selectedGroup = data.groupId;
              this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
              this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
              this.qualityService.activity = {};
              list.STATUS = data.status;
              this.qualityService.activity = data;
              this.qualityService.getQmsActionDataUsingById = {};
              this.popupDataTitle = data.auId;
              if (quickAccess.SUB_ACTIVITY == 'Extension') {
                this.message.taskLevelData = {
                  REF_NO: this.qualityService.activityId,
                  EXTENSION_ID: quickAccess.SUB_ACTIVITY_NO,
                  subModuleName: quickAccess.SUB_ACTIVITY
                }
              } else if (data.subModuleName == 'Parallel Workflow') {
                this.message.taskLevelData = {
                  WORKFLOW_ID: data.subTaskNo,
                  subModuleName: data.subModuleName
                }
                this.qualityService.workflowId = this.message.taskLevelData.WORKFLOW_ID;
                this.router.navigate(['dashboard/parallelworkflowDetails']);
              } else if (quickAccess.SUB_ACTIVITY == 'Findings') {
                this.visibleConfirmFinding = this.dialog.open(this.confirmFindingPopup, this.confirmFindingPopupConfig);
              } else if (quickAccess.SUB_ACTIVITY == 'Followups' || quickAccess.SUB_ACTIVITY == 'Followup') {
                this.message.taskLevelData = {
                  AU_NO: this.qualityService.activityId,
                  FOLLOWUP_ID: quickAccess.SUB_ACTIVITY_NO,
                  subModuleName: quickAccess.SUB_ACTIVITY
                }
              }

            });


          }
          else if (this.auService.auditScheduleStatusList.indexOf(data.status) != -1) {
            this.auService.tabName = "Annual Audit Schedule";
            this.isProcessing = false;
            //this.qualityService.auditEditmodeDatas = { pageName: this.selectedTab };

            this.auService.list = {};
            this.message.activityId = this.qualityService.activityId = this.auService.list.AU_NO = data.auNo;
            this.qualityService.selectedActivityGroupId = this.auService.list.GROUP_ID = data.groupId;
            //this.message.breadcrumbData.secondLevel="Audit" +" > "+ this.selectedGroupValue[0].displayExp;
            this.message.breadcrumbData.fourthLevel = this.auService.list.AU_ID = data.auId;
            this.qualityService.activity = {};
            this.qualityService.activity.status = this.auService.list.STATUS = data.status;
            this.qualityService.getQmsActionDataUsingById = {};
            this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
              this.dropDownForAuditGroup = response1;
              this.auService.priorGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == data.groupId);
              this.qualityService.groupNameAndValue = this.selectedGroupValue = [{
                displayExp: this.auService.priorGroup.groupId,
                valueExp: this.auService.priorGroup.groupName
              }];
              this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].groupName;

              this.qualityService.auditEditmodeDatas = { pageName: "Annual Audit Schedule" };
              //this.auComponent.ngOnInit();
              this.isProcessing = false;
            });
            this.isProcessing = false;


          } else if (data.status.includes("Initiated")) {
            this.isProcessing = false;
            this.qualityService.activityDynamicButtonList = [];
            this.auService.tabName = 'Conduct Audit';
            this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
            //this.auComponent.ngOnInit();
            this.qualityService.cancelButtonFrom = "myTask";
            this.appService.getQmsGroupDetailsByModule(data.groupId, this.qualityService.moduleName).subscribe((data1: any) => {
              this.qualityService.selectedGroupDetailData = data1;
            });
            this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qualityService.moduleName).subscribe((response1: any) => {
              this.qualityService.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qualityService.userRole[0].groupId,
                displayExp: this.qualityService.userRole[0].groupName
              }];
              this.qualityService.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qualityService.groupNameAndValue = this.selectedGroupValue;
              this.qualityService.selectedGroupDetailId = response1[0].groupDetailId;
              if (this.qualityService.userRole[0]?.qmsRoles.includes("Auditor")) {
                this.qualityService.loggedAuditor = true;
              } else {
                this.qualityService.loggedAuditor = false;
              }

              this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
              let list: any = {};
              this.message.activityId = this.qualityService.activityId = list.AU_NO = data.auNo;
              this.qualityService.selectedActivityGroupId = list.GROUP_ID = data.groupId;
              this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
              this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
              this.qualityService.activity = {};
              this.qualityService.activity.status = list.STATUS = data.status;
              this.qualityService.getQmsActionDataUsingById = {};
              this.router.navigate(['/dashboard/auDetailPage']);

            });



          } else if (this.auService.auditPlanStatusList.indexOf(data.status) != -1) {
            this.auService.tabName = "Audit Plan";
            //this.qualityService.auditEditmodeDatas = { pageName: this.selectedTab };
            this.appService.getQmsGroupDetailsByModule(data.groupId, this.qualityService.moduleName).subscribe((data1: any) => {
              this.qualityService.selectedGroupDetailData = data1;
            });
            this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qualityService.moduleName).subscribe((response1: any) => {
              this.qualityService.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qualityService.userRole[0].groupId,
                displayExp: this.qualityService.userRole[0].groupName
              }];
              this.qualityService.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qualityService.groupNameAndValue = this.selectedGroupValue;
              if (this.qualityService.userRole[0]?.qmsRoles.includes("Auditor")) {
                this.qualityService.loggedAuditor = true;
              } else {
                this.qualityService.loggedAuditor = false;
              }

              this.auService.list = {};
              this.message.activityId = this.qualityService.activityId = this.auService.list.AU_NO = data.auNo;
              this.qualityService.selectedActivityGroupId = this.auService.list.GROUP_ID = data.groupId;
              this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
              this.message.breadcrumbData.fourthLevel = this.auService.list.AU_ID = data.auId;
              this.qualityService.activity = {};
              this.qualityService.activity.status = this.auService.list.STATUS = data.status;
              this.qualityService.getQmsActionDataUsingById = {};
              this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
                this.dropDownForAuditGroup = response1;

                this.auService.priorGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == data.groupId);
                this.qualityService.auditEditmodeDatas = { pageName: "Audit Plan" };
                //this.auComponent.ngOnInit();
                this.isProcessing = false;
              });
              this.isProcessing = false;

            });


            this.isProcessing = false;
          } else {
            this.isProcessing = false;
            this.qualityService.activityDynamicButtonList = [];
            this.auService.tabName = 'Conduct Audit';
            this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
            //this.auComponent.ngOnInit();
            this.qualityService.cancelButtonFrom = "myTask";
            this.appService.getQmsGroupDetailsByModule(data.groupId, this.qualityService.moduleName).subscribe((data1: any) => {
              this.qualityService.selectedGroupDetailData = data1;
            });
            this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qualityService.moduleName).subscribe((response1: any) => {
              this.qualityService.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qualityService.userRole[0].groupId,
                displayExp: this.qualityService.userRole[0].groupName
              }];
              this.qualityService.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qualityService.groupNameAndValue = this.selectedGroupValue;
              this.qualityService.selectedGroupDetailId = response1[0].groupDetailId;
              if (this.qualityService.userRole[0]?.qmsRoles.includes("Auditor")) {
                this.qualityService.loggedAuditor = true;
              } else {
                this.qualityService.loggedAuditor = false;
              }

              this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
              let list: any = {};
              this.message.activityId = this.qualityService.activityId = list.AU_NO = data.auNo;
              this.qualityService.selectedActivityGroupId = list.GROUP_ID = data.groupId;
              this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
              this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
              this.qualityService.activity = {};
              this.qualityService.activity.status = list.STATUS = data.status;
              this.qualityService.getQmsActionDataUsingById = {};
              this.router.navigate(['/dashboard/auDetailPage']);

            });



          }
        });
        break;

      case 'DOCS':
        this.documentsNavigation(quickAccess);
        break;

      case 'TRN':
        this.trainingsNavigation(quickAccess);
        break;

      case 'INSTTRN':
        this.instructorTrainingNavigation(quickAccess);
        break;
    }
  }
  selectedGroupValue: any;
  activityNavigation(quickAccess: any, activityData: any) {

    const firstRequest$ = this.appService.getQmsGroupDetailsByModule(activityData.groupId, this.qualityService.moduleName);
    const secondRequest$ = this.appService.getQmsActiveUserByGroupIdModuleUserId(activityData.groupId, this.qualityService.moduleName);

    let thirdRequest$;

    if (quickAccess.MODULE_CODE !== 'IN' && quickAccess.MODULE_CODE !== 'CC') {
      thirdRequest$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Effectiveness Check Performer');
    } else {
      thirdRequest$ = scheduled([null], asyncScheduler);
    }

    forkJoin([firstRequest$, secondRequest$, thirdRequest$]).subscribe({
      next: ([groupDetails, groupUsers, activeGroupUsers]) => {
        this.isProcessing = false;
        this.qualityService.selectedGroupDetailData = groupDetails;
        this.qualityService.userRole = groupUsers;
        this.qualityService.selectedGroupDetailId = this.qualityService.userRole[0]?.groupDetailId;
        this.qualityService.loggedInitiaor = this.qualityService.userRole[0]?.qmsRoles.includes("Initiator");
        activeGroupUsers && (this.dropDownForOwner = activeGroupUsers, this.selectBoxForOwner());
        this.subActivityNavigation(quickAccess, activityData);
        (!quickAccess.SUB_ACTIVITY && activityData.status != "Closed(Effectiveness Check Pending)") && (this.processModuleRouting(quickAccess.MODULE_CODE), this.message.breadcrumbData.fourthLevel = quickAccess.ACTIVITY_NO);
      },
      error: error => {
        console.error('Error:', error);
      }
    });
  }

  subActivityNavigation(quickAccess: any, activityData: any) {
    let checkReqForValue: any = [];

    if (quickAccess.SUB_ACTIVITY_NAME != null) {
      if (quickAccess.SUB_ACTIVITY_NAME.includes("-")) {
        checkReqForValue = quickAccess.SUB_ACTIVITY_NAME.split("- ");
      }
    }

    if (activityData.status == "Closed(Effectiveness Check Pending)") {
      this.popupDataTitle = "Create Effectiveness Check";
      [this.selectedCheckRequiredFor, this.selectedCheckRequiredFor, this.ecData.dueDate, this.ecData.remindNDaysBeforeDueDate] = [[], [], null, ''];
      this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
    }

    switch (quickAccess.SUB_ACTIVITY) {

      case 'Effectiveness Check':
        this.message.taskLevelData = {
          EC_ID: quickAccess.SUB_ACTIVITY_NO,
          CHECK_REQD_FOR: checkReqForValue[1],
          subModuleName: quickAccess.SUB_ACTIVITY,
          REF_NO: this.qualityService.activityId
        }
        break;

      case 'Actions':
        this.message.taskLevelData = {
          ACTION_ID: quickAccess.SUB_ACTIVITY_NO,
          subModuleName: quickAccess.SUB_ACTIVITY
        }
        break;

      case 'Extension':
        this.message.taskLevelData = {
          REF_NO: this.qualityService.activityId,
          EXTENSION_ID: quickAccess.SUB_ACTIVITY_NO,
          subModuleName: quickAccess.SUB_ACTIVITY
        }
        break;
    }
  }

  processModuleRouting(moduleCode: any) {
    switch (moduleCode) {
      case 'CR':
        this.router.navigate(['dashboard/qmsCr']);
        break;
      case 'CAPA':
        this.router.navigate(['dashboard/capa']);
        break;
      case 'DV':
        this.router.navigate(['dashboard/dv']);
        break;
      case 'IN':
        this.router.navigate(['dashboard/in']);
        break;
      case 'QI':
        this.router.navigate(['dashboard/qi']);
        break;
      case 'CC':
        this.router.navigate(['dashboard/cc']);
        break;
    }
  }

  auditNavigation(quickAccess: any, auditData: any) {
    const list: any = {
      AU_NO: auditData.auNo,
      GROUP_ID: auditData.groupId,
      AU_ID: auditData.auId,
      STATUS: auditData.status
    };

    if (quickAccess.SUB_ACTIVITY == 'Extension') {
      this.message.taskLevelData = {
        REF_NO: this.qualityService.activityId,
        EXTENSION_ID: quickAccess.SUB_ACTIVITY_NO,
        subModuleName: quickAccess.SUB_ACTIVITY
      }

    } else if (quickAccess.SUB_ACTIVITY == 'Findings') {
      this.auService.tabName = 'Conduct Audit';
      this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
      this.qualityService.activityDynamicButtonList = [];
      this.auService.findingId = quickAccess.SUB_ACTIVITY_NO;
      this.visibleConfirmFinding = this.dialog.open(this.confirmFindingPopup, this.confirmFindingPopupConfig);

    } else if (this.auService.auditScheduleStatusList.includes(auditData.status)) {
      this.auService.tabName = "Annual Audit Schedule";
      this.qualityService.auditEditmodeDatas = { pageName: "Annual Audit Schedule" };
      this.auService.list = list;
      this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
        this.dropDownForAuditGroup = response1;
        this.auService.priorGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == auditData.groupId);
      });

    } else if (this.auService.auditPlanStatusList.includes(auditData.status)) {
      this.auService.tabName = "Audit Plan";
      this.qualityService.auditEditmodeDatas = { pageName: "Audit Plan" };
      this.auService.list = list;
      this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
        this.dropDownForAuditGroup = response1;
        this.auService.priorGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == auditData.groupId);
      });

    } else {
      this.qualityService.activityDynamicButtonList = [];
      this.auService.tabName = 'Conduct Audit';
      this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
      this.router.navigate(['/dashboard/auDetailPage']);
    }
  }

  cancelFindings() {
    this.visibleConfirmFinding.close();
  }

  documentsNavigation(quickAccess: any) {
    this.isProcessing = true;
    this.appService.getDocumentByDocumentId(quickAccess.TASK_NO, quickAccess.VERSION).subscribe((data: any) => {
      this.documentData = data[0];
      this.appService.setParentFolderId(this.documentData.folderId);
      this.appService.getDocumentTypeBasedOnModule("DOCS").subscribe((data: any) => {
        this.dropDownFordocumentTypeList = data;
        this.isProcessing = false;
        this.router.navigate(['/dashboard/addDocument'],
          {
            state: {
              documentData: this.documentData,
              dropDownFordocumentTypeList: this.dropDownFordocumentTypeList
            }
          }
        );
      })
    })
  }

  trainingsNavigation(quickAccess: any) {
    this.isProcessing = true;
    this.appService.getTrainingByTrainingId(quickAccess.TASK_NO, quickAccess.VERSION).subscribe((data: any) => {
      this.isProcessing = false;
      this.trainingData = data[0];
      this.trainingData['isFromDashboard'] = true;
      this.appService.getCategoriesList().subscribe((data: any) => {
        this.dropDownForCategories = data;
        this.appService.setTrainingDetails(this.dropDownForCategories, this.trainingData);
        this.message.breadcrumbData.firstLevel = "Dashboard";
        this.message.breadcrumbData.secondLevel = "My Task";
        this.message.breadcrumbData.thirdLevel = "Add Training";
        this.router.navigate(['/dashboard/addTraining']);
      })
    })
  }

  instructorTrainingNavigation(quickAccess: any) {
    this.isProcessing = true;
    this.appService.getScheduledTrainingById(quickAccess.TASK_NO).subscribe((response: any) => {
      this.scheduledTrainingData = response[0];
      this.isProcessing = false;
      this.scheduledTrainingData.isShowTrainingAssessmentFlag = false;
      this.scheduledTrainingData.isFromDashboard = true;
      this.scheduledTrainingData.allowUsersToTakeAssessmentAtApplication = this.scheduledTrainingData.allowUsersToTakeAssessmentAtApplication == "Y";
      this.scheduledTrainingData.allowUsersToTakeAssessmentAtApplication1 = this.scheduledTrainingData.allowUsersToTakeAssessmentAtApplication;
      this.scheduledTrainingData.scheduledStartDate = new Date(this.scheduledTrainingData.scheduledStartDate);
      this.scheduledTrainingData.scheduledEndDate = new Date(this.scheduledTrainingData.scheduledEndDate);
      this.router.navigate(['/dashboard/scheduleTrainingDetail'], {
        state: {
          isShowTakeAssessmentField: false,
          trainingScheduleId: this.scheduledTrainingData.trainingScheduleId
        }
      });
    })
  }

  selectBoxForOwner() {
    this.ownerListDropdown = [];
    this.ownerListDropdown = this.dropDownForOwner.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })) || []
  }

  @ViewChild('addPopup', { static: true }) addPopup: TemplateRef<any>;
  visibleAddPopup: MatDialogRef<TemplateRef<any>>;

  addPopupConfig = {
    width: '50%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  visibleConfirmFinding: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmFindingPopup', { static: true }) confirmFindingPopup: TemplateRef<any>;

  confirmFindingPopupConfig = {
    width: '90%',
    height: '85%',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat;
  dueDatePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date()
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onCheckRequiredForSelect(item: any) {

  }

  onCheckRequiredForRemoved(item: any) {

  }

  onOwnerSelect(item: any) {

  }

  onOwnerRemoved(item: any) {

  }

  dueDateOnChanged(items: any) {

  }

  fieldValidation() {

  }

  addFunction(ecData: any) {
    if (this.selectedCheckRequiredFor.length < 1 || this.selectedOwner.length < 1 || this.ecData.dueDate == null) {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
    } else {
      this.isProcessing = true;

      const ecObj = {
        module: this.qualityService.moduleName,
        refNo: this.qualityService.activityId,
        remindNDaysBeforeDueDate: this.ecData.remindNDaysBeforeDueDate,
        checkReqdFor: this.selectedCheckRequiredFor[0]?.valueExp ?? null,
        owner: this.selectedOwner[0]?.valueExp ?? null,
        dueDate: ecData.dueDate ? new Date(this.ecData.dueDate) : null,
      }

      this.appService.createQmsTasksEC(ecObj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.visibleAddPopup.close();
            this.getcallMethod();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelAddPopup() {
    this.visibleAddPopup.close();
  }


  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: !this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.secondLevel
          : this.message.breadcrumbData.thirdLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  tempGrid: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';

  getcallMethod() {
    this.isProcessing = true;
    const data = {

      gridName: "QUICK_ACCESS",
      groupId: this.qualityService.selectedGroup
    }
    this.appService.getDynamicGridHeaders(data).subscribe((response: any) => {
      response.orderByClause = response.orderByClause ? response.orderByClause : "";
      this.makeStickyColumns = response.fixedFieldCnt;
      const data1: any = {

        gridName: "ONEQMS_MY_QUICK_ACCESS_VW",
        tableOrViewName: response.tableOrViewName ?? "",
        columnsList: response.columnsList ?? "",
        fieldLabelsList: response.fieldLabelsList ?? "",
        invisibleColumn: response.invisibleColumn ?? "",
        orderByClause: response.orderByClause ?? "",
        fieldSizeList: response.fieldSizeList ?? "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        clobColumnlist: response.closblist || "",
        blobColumnlist: response.bloblist || ""
      }
      this.appService.getDynamicGridData(data1).subscribe((response1: any) => {
        this.grid = response1;
        data1.columnsListarray = data1.columnsList.split(",");
        data1.fieldColumnarray = data1.fieldLabelsList.split(",");
        data1.invisibleColumnarray = data1.invisibleColumn.split(",");
        data1.fieldSizeListArray = data1.fieldSizeList.split(",");
        this.columnLists.columnsListarray = data1.columnsListarray;
        this.columnLists.fieldLabelsList = data1.fieldLabelsList;
        this.columnLists.fieldColumnarray = [];
        for (let p = 0; p < data1.fieldColumnarray.length; p++) {
          this.columnLists.fieldColumnarray.push({
            "fieldColumnarray": data1.fieldColumnarray[p],
            "width": data1.fieldSizeListArray[p] + 'px'
          })
        }
        this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
        this.columnLists.fieldSizeListArray = [];
        for (const element of data1.fieldSizeListArray) {
          this.columnLists.fieldSizeListArray.push(element + 'px');
        }
        for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
          for (const element of this.columnLists.invisibleColumnarray) {
            if (this.columnLists.columnsListarray[y] == element) {
              this.columnLists.columnsListarray.splice(y, 1);
              this.columnLists.fieldColumnarray.splice(y, 1);
              this.columnLists.fieldSizeListArray.splice(y, 1);
            }
          }
        }
        let tableData = {
          tablename: data1.tableOrViewName
        };
        this.columnLists.columnsListarray1 = [];
        this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
          this.dataTypeList = response2;
          for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
            this.columnLists.columnsListarray1.push({});
            this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
            this.columnLists.columnsListarray1[m].dataType = "textbox";
            this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
            for (const element of this.dataTypeList) {
              if (element.columnName == this.columnLists.columnsListarray[m]) {
                this.columnLists.columnsListarray1[m].dataType = element.fieldType;
              }
            }
          }
          for (const rowData of this.grid) {
            for (const element of this.dataTypeList) {
              if (element.fieldType === 'CHECKBOX') {
                rowData[element.columnName] = rowData[element.columnName] === 'Y';
              }
            }
          }
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        });
        this.message.gridList = this.grid;
        this.collectionSize = this.grid.length;
        this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
        this.isProcessing = false;
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
      this.isProcessing = false;
    }, (error) => {
      this.isProcessing = false;
      throw error;
    });
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetpage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.tempGrid.length > 0) {
      this.pager = this.paginationService.getPager(this.tempGrid.length, page, this.perPage, targetpage);
      this.pagedItems = this.tempGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }


  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.tempGrid = this.grid;
      this.pager = this.paginationService.getPager(this.tempGrid.length, 1, this.perPage, 0);
      this.pagedItems = this.tempGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter != undefined) {
        this.tempGrid = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.tempGrid = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          let keyValue = p / 2;
          column.style.background = keyValue == Math.floor(keyValue) ? 'white' : 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {
    console.log("event");
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.grid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.grid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getcallMethod();
  }


}

